import { createActions, using } from 'redux-box';

export const actions = createActions({
  requestWords: using("offset, search, gradeId"),
  setWords: using("words"),
  setPagination: using("pagination"),
  setLoading: using("isLoading"),
  createWord: using("payload"),
  updateWord: using("id, payload"),
  deleteWord: using("id")
});
